const EXPIRY_STORAGE_PREFIX = 'whoispaying:expiry:';

export function storeExpiryForRoom(roomId, value) {
  if (!roomId || typeof window === 'undefined') return null;
  const date = typeof value === 'string' ? new Date(value) : value instanceof Date ? value : null;
  if (!date || isNaN(date.getTime())) return null;
  const iso = date.toISOString();
  try {
    window.sessionStorage.setItem(`${EXPIRY_STORAGE_PREFIX}${roomId}`, JSON.stringify({ expiresAt: iso, savedAt: new Date().toISOString() }));
  } catch {}
  return iso;
}

export function readStoredExpiryForRoom(roomId) {
  if (!roomId || typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(`${EXPIRY_STORAGE_PREFIX}${roomId}`);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    return obj?.expiresAt ?? null;
  } catch {
    return null;
  }
}
